import { render, staticRenderFns } from "./updateCustomerInfo.vue?vue&type=template&id=31cf4c2e&scoped=true&"
import script from "./updateCustomerInfo.vue?vue&type=script&lang=js&"
export * from "./updateCustomerInfo.vue?vue&type=script&lang=js&"
import style0 from "./updateCustomerInfo.vue?vue&type=style&index=0&lang=css&"
import style1 from "./updateCustomerInfo.vue?vue&type=style&index=1&id=31cf4c2e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31cf4c2e",
  null
  
)

export default component.exports